module.exports = __webpack_public_path__ + "img/h_logo.b7bf18af.png";